import { Theme } from 'theme-ui';

const makeTheme = <T extends Theme>(t: T) => t;

// Spacing
let space = ['0.5rem', '0.75rem', '1rem', '1.25rem', '1.5rem', '3rem'];

space['xs'] = '0.5rem';
space['s'] = '0.75rem';
space['m'] = '1rem';
space['l'] = '1.25rem';
space['xl'] = '1.5rem';
space['xxl'] = '3rem';

// Breakpoints

const theme = makeTheme({
  // Color mapping used from app/webpacker/stylesheets/color-theme.scss
  colors: {
    text: '#172b4e',
    muted: '#647084',
    primary: '#1A47A6',
    secondary: '#647084',
    //
    success: '#25835c',
    warning: '#fff4de',
    error: '#ff0028',
    info: '#1A47A6',
    //
    grayscale: {
      black: '#000000',
    },
  },
  opacities: {
    overlay: '0.8',
  },
  space,
  breakpoints: ['767px', '992px', '1200px'],
  zIndices: {
    // Used MUI as a reference. We can change this later if we need to.
    // See: https://mui.com/customization/z-index/
    drawer: 1200,
  },
  text: {
    default: {
      color: 'text',
    },
  },
  fontWeights: {
    bold: 600,
  },
  buttons: {
    unstyled: {
      color: 'text',
      padding: '0px',
      background: 'none',
      border: '0',
    },
    icon: {
      color: 'primary',
      width: '2rem',
      height: '2rem',
      margin: '1rem',
      ml: 'auto',
      padding: '0px',
      background: 'none',
      border: '0',
    },
  },
  styles: {
    body: {
      // override margin added by theme-ui
      margin: '0px',
    },
  },
});

export default theme;
